import type { MouseEvent } from 'react';
import { createElement } from 'react';
import { ArrowDownIcon, CloseIcon } from '~/icons';

export const MuiAutocomplete = {
  defaultProps: {
    popupIcon: createElement(ArrowDownIcon, { color: '#1010EB' }),
    clearIcon: createElement(CloseIcon),
    fullWidth: true,
    slotProps: {
      chip: {
        clickable: true,
        size: 'small',
        sx: {
          fontSize: '1.4rem',
          backgroundColor: '#140F4B1F',
          color: '#000000C4',
          '&.Mui-disabled': {
            opacity: 1,
          },
        },
        deleteIcon: createElement(CloseIcon, {
          style: {
            width: 14,
            height: 14,
            marginRight: 10,
            color: '#1010EB',
          },
          onMouseDown: (event: MouseEvent) => event.stopPropagation(),
        }),
      },
    },
  },
  styleOverrides: {
    root: {
      '&.Mui-disabled': {
        backgroundColor: '#DCDCDC',
      },
      backgroundColor: '#fff',
    },
  },
};
